import { Box } from '@mui/material'
import React from 'react'

import {
  GeotokenSettingsCoinSponsorStatusProperty,
  GeotokenSettingsDescriptionProperty,
  GeotokenSettingsImageProperty,
  GeotokenSettingsLinkProperty,
  GeotokenSettingsSponsorProperty,
  GeotokenSettingsTitleProperty,
} from '../../../../Properties'

const SettingsDetails: React.FC = () => {
  return (
    <Box alignItems="stretch" display="flex" flexDirection="column" flexGrow={1}>
      <GeotokenSettingsTitleProperty />
      <GeotokenSettingsDescriptionProperty />
      <GeotokenSettingsSponsorProperty />
      <GeotokenSettingsLinkProperty />
      <GeotokenSettingsImageProperty />
      <GeotokenSettingsCoinSponsorStatusProperty />
    </Box>
  )
}

export default SettingsDetails
